export var ResultStatus;

(function (ResultStatus) {
  ResultStatus["Initial"] = "initial";
  ResultStatus["Requested"] = "requested";
  ResultStatus["Ready"] = "ready";
  ResultStatus["Failed"] = "failed";
})(ResultStatus || (ResultStatus = {}));
//# sourceMappingURL=types.js.map